import {
  ApiKey,
  CopyToClipboard,
  darkThemeStyles,
  JupiterTheme,
} from '@jupiterone/jupiter-web-toolkit';
import {
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles, useTheme } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { Clipboard } from 'react-feather';
import useSharedUsersAndAccountStyles from '../useSharedUsersAndAccountStyles';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    ...darkThemeStyles,
    spacingTop: {
      marginTop: theme.spacing(4),
    },
    clipboard: {
      color: theme.palette.navy[50],
    },
    warningText: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      backgroundColor: theme.palette.red[400],
      borderRadius: 4,
    },
  })
);

interface Props {
  keyValue: ApiKey['key'];
}

const GeneratedApiKey = ({ keyValue }: Props) => {
  const classes = useStyles();
  const sharedClasses = useSharedUsersAndAccountStyles();
  const theme: JupiterTheme = useTheme();

  return (
    <div className={sharedClasses.centerContent}>
      <Typography
        variant="h6"
        align="center"
        className={clsx(classes.textInput, classes.warningText)}
      >
        This is the only time this key will be visible!
      </Typography>
      <Typography
        variant="caption"
        className={clsx(classes.textInput, classes.spacingTop)}
      >
        Copy this API key into any application that needs access to the
        JupiterOne API. Treat this API Key as senstive information like your
        password. This key will not be visible again. If you lose it, you should
        remove the API key and create a new one.
      </Typography>
      <TextField
        label=""
        value={keyValue}
        InputLabelProps={{
          classes: {
            root: classes.textInputLabelFocused,
            focused: classes.textInputLabelFocused,
          },
        }}
        InputProps={{
          className: classes.textInput,
          classes: {
            root: classes.textInputLabelFocused,
          },
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip placement="bottom" title="Copy to clipboard">
                <span>
                  <CopyToClipboard text={keyValue}>
                    <IconButton>
                      <Clipboard color={theme.palette.navy[100]} />
                    </IconButton>
                  </CopyToClipboard>
                </span>
              </Tooltip>
            </InputAdornment>
          ),
        }}
        margin="normal"
        fullWidth={true}
      />
    </div>
  );
};

export default GeneratedApiKey;
